import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CopyrightFooterComponent } from './copyright/copyrightFooter.component';

/*
 * Container including the Footer of App Store.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-footer",
  standalone: true,
  imports: [
    CopyrightFooterComponent
  ],
  template: `
      <div class="page-footer">
          <ama-ng-copyright-footer></ama-ng-copyright-footer>
      </div>
  `
})
export class FooterComponent {}
